export const SPECIAL_LOGIN_ORDER_ID_QUERY_KEY = 'order_id'

export const LOGIN_METHOD = {
  SMS: 'sms',
  EMAIL: 'email',
  LINE: 'line',
  FACEBOOK: 'facebook',
  GOOGLE: 'google',
} as const
export type LoginMethodValue = typeof LOGIN_METHOD[keyof typeof LOGIN_METHOD]

export const SUBSHIP_TYPE = {
  STAGGERED_SHIPPING: 'staggered_shipping',
  SUBSCRIPTION: 'subscription',
} as const
export type SubshipTypeValue = typeof SUBSHIP_TYPE[keyof typeof SUBSHIP_TYPE]
